/* @flow */
import { useLocation } from 'react-router-dom';

// Hooks
import useRoutes from 'src/shared/app/base/route/hook/useRoutes';
import useEvent from 'src/shared/domain/event/hook/useEvent';
import useFeatureDecisions from 'src/shared/app/feature/hook/useFeatureDecisions';

//
import { peopleFeedRoute } from 'src/shared/app/base/route/setting/routeSettings';
import {
  getEventNavbarSponsors,
  getEventPlugins,
  getEventSponsorPluginLevelIsEnabled,
} from '@braindate/domain/lib/event/util';
import {
  mainNavMenuLevel,
  sponsorshipPlugin as sponsorshipPluginKey,
} from 'src/shared/app/feature/settings/featureSettings';

import type { BraindateEventSponsor } from '@braindate/domain/lib/event/type';

const useSidebar = (
  noSurvey: boolean,
  hideNewTopicButton: boolean,
): {
  hasSidebar: boolean,
  showSurvey: boolean,
  showCreateTopicButton: boolean,
  eventSponsors: BraindateEventSponsor[],
} => {
  // Survey
  const { isProvideFeedbackSectionEnabled } = useFeatureDecisions();
  const showSurvey = !noSurvey && !!isProvideFeedbackSectionEnabled;

  // New topic button
  const location = useLocation();
  const [peopleFeedPath] = useRoutes(peopleFeedRoute);
  const showCreateTopicButton =
    !hideNewTopicButton &&
    (location.pathname === '/' || location.pathname === peopleFeedPath);

  // Event
  const event = useEvent();
  const sponsorshipPlugin = getEventPlugins(event)[sponsorshipPluginKey];
  const isSponsorPluginEnabledForSidebar =
    sponsorshipPlugin &&
    getEventSponsorPluginLevelIsEnabled(sponsorshipPlugin, mainNavMenuLevel);

  const eventSponsors = isSponsorPluginEnabledForSidebar
    ? getEventNavbarSponsors(event)
    : [];

  const hasSidebar =
    showCreateTopicButton ||
    (!!sponsorshipPlugin &&
      !!isSponsorPluginEnabledForSidebar &&
      !!eventSponsors.length) ||
    showSurvey;

  return { hasSidebar, showSurvey, showCreateTopicButton, eventSponsors };
};

export default useSidebar;
